export { default as getPdfTemplates } from './getPdfTemplates';
